module.exports = __webpack_public_path__ + "static/media/akali-win.9ed6fadb.png";